import { ShopSchema } from 'src/models/shop/schema';
import { BackendApiFetch } from 'src/utils/backendApi';
import { errorMessage } from 'src/utils/errorMessage';

const fetchShops = async (
  locale: string,
  lastModified?: string // UTCString
): Promise<ShopSchema[]> => {
  try {
    const response = await BackendApiFetch<ShopSchema[]>({
      path: '/app/v1/shops',
      localeType: locale,
      lastModified,
    });

    if (response.statusCode === 200) {
      return response.data;
    }
    // lastModifiedから変更がない場合は空配列を返す
    return [];
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export { fetchShops };
